
export const meetings = {
  title: "Personal Meeting",
  subtitle: "Live conversation and shared experience",
  description: "Let's meet in person! Choose from different experiences.",
  options: {
    title: "Choose personal meeting type",
    description: "I invite you to a personal meeting! Choose the package that suits your needs best!",
    budapest: {
      title: "Personal visit in Budapest",
      description: "40 minute conversation, photos, extra gift",
      features: [
        "40 minute personal conversation",
        "Photo opportunity",
        "Bocs Tesó gift (mug, flask or t-shirt) with Fanni's signature",
        "At an agreed time and location in Budapest"
      ]
    },
    outOfBudapest: {
      title: "Personal visit outside Budapest",
      description: "40 minute conversation, photos, extra gift",
      features: [
        "40 minute personal conversation",
        "Photo opportunity",
        "Bocs Tesó gift (mug, flask or t-shirt) with Fanni's signature",
        "At an agreed time and location outside Budapest"
      ]
    },
    candy: {
      title: "Cotton candy making together",
      description: "Eat a cotton candy with me at one of our machines",
      features: [
        "10 minute personal conversation",
        "Photo opportunity",
        "Cotton candy making and tasting",
        "Exclusively on weekdays (Duna Plaza, World Mall, Árkád Budapest)"
      ]
    }
  },
  form: {
    title: "order",
    subtitle: "Fill out the form to book a personal meeting",
    fields: {
      name: "Full name",
      email: "Email address",
      phone: "Phone number",
      preferredDates: "Preferred dates",
      notes: "Additional notes"
    },
    placeholders: {
      name: "Enter your name",
      email: "Enter your email address",
      phone: "Enter your phone number",
      preferredDates: "Write a few dates that work for you (e.g. October 15-20, 2023 weekdays afternoon, or early December weekends)",
      notes: "If you have any additional requests or comments, you can write them here"
    }
  }
};
